// extracted by mini-css-extract-plugin
module.exports = {"opcions":"IntroduccioIndividuFenofasesDetallOpcions_opcions__286h0"};